import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/providers/authProvider';
import { ApiProvider } from '@/providers/apiProvider';
import { initPreview } from '@/lib/preview';
import App from './App';
import './index.css';

const queryClient = new QueryClient();

// Portal "Preview in Companion" handshake must settle before first render.
initPreview().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ApiProvider>
            <App />
          </ApiProvider>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
});
